import React, { useEffect } from "react";
import { motion, useMotionValue } from "framer-motion";

const ReadingProgressBar = ({ targetRef }) => {
  const scaleX = useMotionValue(0);

  useEffect(() => {
    const handleScroll = () => {
      const el = targetRef?.current;
      if (!el) {
        const scrollTop = window.scrollY;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        scaleX.set(docHeight > 0 ? scrollTop / docHeight : 0);
        return;
      }

      const rect = el.getBoundingClientRect();
      const elTop = rect.top + window.scrollY;
      const elBottom = elTop + el.offsetHeight;
      const scrollTop = window.scrollY;

      if (scrollTop <= elTop) {
        scaleX.set(0);
      } else if (scrollTop >= elBottom) {
        scaleX.set(1);
      } else {
        scaleX.set((scrollTop - elTop) / (elBottom - elTop));
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [targetRef, scaleX]);

  return (
    <motion.div
      style={{
        scaleX,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 4,
        transformOrigin: "left",
        zIndex: 1500,
        backgroundColor: "hsl(153, 68%, 25%)",
      }}
    />
  );
};

export default ReadingProgressBar;
